import axios from "axios";
import ConfigurationManager from "../../settings/ConfigurationManager";
import React, { useState } from "react";
import MaskedInput from "react-text-mask";
import { Modal, Button, Spinner } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import { celularMaskNew } from "../../utils/inputMask";
import { validationSchemaClaveError } from "../../utils/validationSchemaForm";
import { useNavigate } from "react-router-dom";
import { removeCodigoArea, cleanDigitos } from "../../utils/cleanInputMask";
import "../../assets/css/style.css";
import images from "../../assets/images.tsx";

const ModalAgregarDatosContacto = (props) => {
	let history = useNavigate();

	const initialValues = {
		nombre: "",
		celular: "",
		correo: "",
	};

	const [isLoading, setIsLoading] = useState(false);

	const onSubmit = (values) => {

		setIsLoading(true);
		const body = {
			idNumSol: parseInt(localStorage.getItem("folioSolicitud")),
			nombreCont: values.nombre,
			telefonoCont: removeCodigoArea(cleanDigitos(values.celular)),
			emailCont: values.correo,
		};

		axios.post(`${ConfigurationManager.API_URL}/ContactoExternos/IngresarDatosContactoTerceroBeneficiario`,
			body,
			{ headers: ConfigurationManager.JSON_HEADER }
		).then((response) => {
			history("/paet/cuentas");
			setIsLoading(false);
		}).catch((e) => {
			console.error(e);
			setIsLoading(false);
		});
	}

	return (
		<div>
			<Modal
				{...props}
				dialogClassName="modal-50w"
				aria-labelledby="contained-modal-title-vcenter"
				centered
			>
				<Modal.Header closeButton>
					<Modal.Title id="contained-modal-title-vcenter">
						<div className="row">
							<div className="col-2">
								<img src={images.exclamacion_amarillo} width="62" height="62" alt="alert img" />
							</div>
							<div className="col-10 text-left">
								No has declarado ningún beneficiario.
							</div>
						</div>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Formik
						initialValues={initialValues}
						validationSchema={validationSchemaClaveError}
						onSubmit={onSubmit}
					>
						{(formik) => (
							<Form>
								<div className="form-group input-wrapper">
									<div className="">
										<br />
										Puedes continuar con la solicitud sin agregar beneficiarios,
										pero de todas formas debes registrar los datos de contacto
										de un tercero para poder comunicarnos en caso de ser
										necesario.
									</div>
									<br />
									<div className="">
										<span className="font-weight-bold">
											Ingresa los datos de contacto:
										</span>
									</div>
									<br />
									<Field name="nombre">
										{({ field, meta }) => (
											<div className="form-group input-wrapper">
												<span>Nombre completo</span>
												<input
													{...field}
													type="text"
													className={`form-control form-control-lg ${meta.touched
														? meta.error
															? "is-invalid"
															: "is-valid"
														: ""
														}`}
													id="nombre"
													name="nombre"
													aria-describedby="nombreAyuda"
													autoComplete="off"
												/>
												<small
													id="nombreAyuda"
													className={`form-text ${meta.touched && meta.error ? "is-invalid" : ""
														}`}
												>
													{meta.touched && meta.error
														? meta.error
														: "Ej: Alexander Perez Soto."}
												</small>
											</div>
										)}
									</Field>
									<Field name="celular">
										{({ field, meta }) => (
											<div className="form-group input-wrapper">
												<span>Telefóno de contacto principal</span>
												<MaskedInput
													{...field}
													mask={celularMaskNew}
													type="text"
													className={`form-control form-control-lg ${meta.touched
														? meta.error
															? "is-invalid"
															: "is-valid"
														: ""
														}`}
													id="celular"
													name="celular"
													aria-describedby="celularAyuda"
													placeholder={`(+56) _ ____ ____`}
													autoComplete="off"
												/>
												<small
													id="celularAyuda"
													className={`form-text ${meta.touched && meta.error ? "is-invalid" : ""
														}`}
												>
													{meta.touched && meta.error
														? meta.error
														: "Ingresa 9 dígitos. Ej: 9-9123-4567 o 22-1234567."}
												</small>
											</div>
										)}
									</Field>
									<Field name="correo">
										{({ field, meta }) => (
											<div className="form-group input-wrapper">
												<span>Correo electrónico</span>
												<input
													{...field}
													type="text"
													className={`form-control form-control-lg ${meta.touched
														? meta.error
															? "is-invalid"
															: "is-valid"
														: ""
														}`}
													id="correo"
													name="correo"
													placeholder=""
													autoComplete="off"
													aria-describedby="correoAyuda"
												/>
												<small
													id="correoAyuda"
													className={`form-text ${meta.touched && meta.error ? "is-invalid" : ""
														}`}
												>
													{meta.touched && meta.error
														? meta.error
														: "Ej: aumentatusueldo@afpmodelo.cl"}
												</small>
											</div>
										)}
									</Field>
								</div>
								<div className="justify-content-center d-flex mb-2">
									<Button
										variant="success"
										className="col-md-12"
										type="submit"
										disabled={!(formik.isValid && formik.dirty) || isLoading}
									>
										{isLoading ? <Spinner animation="border" variant="light" size="sm" /> : "Enviar mis datos"}
									</Button>
								</div>
								<div className="justify-content-center d-flex mb-2">
									<Button
										variant="outline-primary"
										className="col-md-12"
										disabled={isLoading}
										onClick={props.onHide}>
										Cerrar
									</Button>
								</div>
							</Form>
						)}
					</Formik>
				</Modal.Body>
			</Modal>
		</div>
	);
};

export default ModalAgregarDatosContacto;
